
const SvgLupa: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={`h-10 w-10 sm:h-8 sm:w-8 md:h-7 md:w-7 text-blue-600 hover:text-blue-800 transition-all duration-500 ease-out ${className}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <defs>
      {/* Gradiente principal */}
      <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#60a5fa" /> {/* azul claro */}
        <stop offset="100%" stopColor="#1d4ed8" /> {/* azul intenso */}
      </linearGradient>

      {/* Brillo animado */}
      <linearGradient id="shine" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="white">
          <animate
            attributeName="offset"
            values="-0.5; 1.5"
            dur="2.8s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="0.5" stopColor="transparent" />
      </linearGradient>
    </defs>

    {/* Círculo principal */}
    <circle
      cx="11"
      cy="11"
      r="7"
      stroke="url(#grad)"
      strokeWidth="1"
      fill="none"
    >
      <animate
        attributeName="r"
        from="7"
        to="7.5"
        dur="0.4s"
        begin="mouseover"
        fill="freeze"
      />
      <animate
        attributeName="r"
        from="7.5"
        to="7"
        dur="0.4s"
        begin="mouseout"
        fill="freeze"
      />
    </circle>

    {/* Brillo animado */}
    <circle
      cx="11"
      cy="11"
      r="7"
      stroke="url(#shine)"
      strokeWidth="0.5"
      fill="none"
      opacity="0.6"
    />

    {/* Mango */}
    <line
      x1="16.65"
      y1="16.65"
      x2="21"
      y2="21"
      stroke="url(#grad)"
      strokeWidth="1.5"
    >
      <animateTransform
        attributeName="transform"
        type="scale"
        from="1"
        to="1.1"
        dur="0.3s"
        begin="mouseover"
        fill="freeze"
      />
      <animateTransform
        attributeName="transform"
        type="scale"
        from="1.1"
        to="1"
        dur="0.3s"
        begin="mouseout"
        fill="freeze"
      />
    </line>

    {/* Cristal translúcido */}
    <circle cx="11" cy="11" r="3" fill="url(#grad)" opacity="0.25" />
  </svg>
);

export default SvgLupa;
